import { Flex, Skeleton, Typography } from 'antd';
import InfoTooltip from 'components/info/info';
import Riyal from 'components/riyal/riyal';
import { isRTL } from 'core/services/language';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface DisabledElementProps {
	value: string | number | undefined | ReactNode | null;
	label?: string;
	fullWidth?: boolean;
	style?: React.CSSProperties;
	addonAfter?: React.ReactNode;
	showPrice?: boolean;
	loading?: boolean;
	info?: string;
}

function DisabledElement({ value, label, fullWidth, style, addonAfter, showPrice, loading, info }: DisabledElementProps) {
	const { t } = useTranslation();

	return (
		<>
			<Flex gap={5} align="center">
				{label && <Typography.Text style={{ fontSize: 15, marginBottom: 5, display: 'inline-block' }}>{label}</Typography.Text>}
				{info && <InfoTooltip title={info} />}
			</Flex>

			{loading ? (
				<Skeleton.Button
					active
					className="w-100"
					style={{ height: 40, maxWidth: 'var(--inputWidth)', borderRadius: 'var(--radius)', marginBottom: 10 }}
				/>
			) : (
				<div
					style={{
						background: '#f9fafb',
						border: '1px solid #d9d9d9',
						padding: '8px 11px',
						borderRadius: 'var(--radius)',
						marginBottom: 10,
						cursor: 'default',
						maxWidth: fullWidth ? 'unset' : 'var(--inputWidth)',
						display: addonAfter || showPrice ? 'flex' : 'block',
						justifyContent: addonAfter || (showPrice && isRTL()) ? 'space-between' : 'unset',
						alignItems: addonAfter || showPrice ? 'center' : 'unset',
						gap: addonAfter || showPrice ? 10 : 0,
						...style,
					}}>
					{!isRTL() && showPrice && <Riyal />}

					{typeof value === 'string' || typeof value === 'number' ? String(value) || t('COMMON.N_A') : value}

					{isRTL() && showPrice && <Riyal />}

					{addonAfter}
				</div>
			)}
		</>
	);
}

export default DisabledElement;
